import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Container } from "reactstrap"
// import MySwiper from "../components/swiper/swiper"
import SampleForm from "../components/form/form"
import { LazyLoadImage } from "react-lazy-load-image-component"
import "react-lazy-load-image-component/src/effects/blur.css"
import bsns from "../images/business.svg"
// import finance from "../images/financial.svg"
// import jigsaw from "../images/jigsaws.svg"
// import report from "../images/report.svg"
// import trophy from "../images/trophy.svg"
import "../components/container-styles.css"
import WebriQForm from "@webriq/gatsby-webriq-form"
import svcIcon1 from "../images/svc-img-4.svg"
import svcIcon2 from "../images/svc-img-3.svg"

import SwiperTest from "../components/swiper/swiper-test"

import search from "../images/magnifying-glass.png"

class IndexPage extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description
    const posts = this.props.data.allSanityPost.edges
    console.log(posts)
    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="Management Insight" description={siteDescription} />

        <div className="container-fluid heroes-section p-relative">
          <div className="row">
            <div className="col-12 col-lg-6 mobile-hero p-relative">
              <div className="row hero-row">
                <div className="col-lg-6 vh-100 hero-col-1 overflow-hidden" />
                <div className="col-lg-6 vh-100 hero-col-2" />
                <div className="brandstamp">
                  <h1>
                    <strong>It’s Simple...</strong>
                    <br />
                    <strong>
                      <span className="atf-line2">But It’s Not Easy</span>
                    </strong>
                  </h1>
                  <p className="mb-5">
                    Management Insight guides CEOs, executives and leadership
                    teams in creating healthier, more effective, high-trust
                    organizations.
                    <br />
                  </p>
                  <Link
                    to="/contact-us"
                    className="btn-global main-cta hvr-bounce-to-right mt-5"
                  >
                    Contact Us
                  </Link>
                  <Link
                    to="/interviews-webinars"
                    className="btn-global main-cta hvr-bounce-to-right mt-5 ml-5"
                  >
                    Interviews/Webinars/Articles
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 hero-col-3 p-relative">
              <div className="cat-scan ">
                <div class="text-right catscan-mobile  float-right ">
                  <Link to="/risk-assessment-and-development-tools">
                    <div class="cat-scan-hover">
                      <figure class="cat-scan-reveal">
                        <img className="search-icon" src={search} />
                      </figure>
                      <span className="text-white">Company CAT-Scan</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="mobile-brandstamp">
            <h1>
              <strong>It’s Simple...</strong>
              <br />
              <strong>
                <span className="atf-line2">But It’s Not Easy</span>
              </strong>
            </h1>
            <p className="mb-5">
              Management Insight helps executives and leadership teams create
              healthier, more effective, high-trust organizations.
              <br />
            </p>
            <a
              href="tel:3038838001"
              className="btn-global main-cta hvr-bounce-to-right mt-5"
            >
              Call Us Today!
            </a>
            <br/>
            <Link
              to="/interviews-webinars"
              className="btn-global main-cta hvr-bounce-to-right mt-5"
            >
              Interviews/Webinars/Articles
            </Link>
          </div>
          <div className="scroll-down p-relative">
            <Link
              className="text-white p-0 m-0 text-decoration-none hvr-icon-forward"
              to="#scrolldown"
            >
              SCROLL DOWN
              <i className="fa fa-caret-right ml-3 hvr-icon" />
            </Link>
          </div>
        </div>

        <div className="container-fluid about-section px-0" id="scrolldown">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6 wwd-col-img " />
              <div className="col-lg-6 about-col-content p-relative d-flex justify-content-center align-items-center p-4">
                <div className="about-inner-content py-5 p-relative flair ">
                  <h4 className="mb-0 mt-0 text-teal">ABOUT US</h4>
                  <h2 className="mt-0 p-relative">What We Do</h2>
                  <p style={{ fontSize: "18px" }}>
                    Management Insight helps you, your business or your
                    organization achieve alignment to move through life more
                    deliberately, joyously and with clear intention. We empower
                    awareness of action, leaving less to chance through default
                    decision making. By building a culture of connection and
                    trust we help foster highly productive businesses that
                    people enjoy working for.
                    <br />
                  </p>
                  <Link
                    to="/what-we-do"
                    className="btn-global hvr-bounce-to-right mt-5"
                    type="button"
                  >
                    <i class="fa fa-book mr-2" /> Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="row container-fluid about-section px-0 ml-0"
          id="scrolldown"
        >
          <div className="col-lg-6 svc-header p-relative d-flex justify-content-center align-items-center p-4 fd-section">
            <div className="about-inner-content py-5 p-relative text-white">
              <h4 className="mb-0 mt-0">FIND DIRECTION</h4>

              <h2 className="mt-0 p-relative">
                Leadership and Executive Coaching
              </h2>
              <p style={{ fontSize: "18px" }}>
                Whether it's business or personal; if you’re completely baffled
                or you just want some clues as to how to move yourself or your
                business forward, we help you gain a better understanding of
                what you can do to get things back on track quickly with clarity
                and the tools to do it.
              </p>
              <Link
                to="/executive-and-leadership-coaching"
                className="hvr-bounce-to-right-reverse mt-3 btn-reverse"
              >
                Learn More
              </Link>
            </div>
          </div>
          <div className="col-lg-6 svc-image p-relative" />
        </div>

        <div className="container-fluid what-we-do px-0">
          <div className="container-fluid">
            <div className="row flex-column-reverse flex-lg-row">
              <div className="col-lg-6 about-col-img" />
              <div className="col-lg-6 wwd-col-content p-relative d-flex justify-content-center align-items-center p-4">
                <div className="wwd-inner-content py-5 p-relative flair">
                  <h4 className="mb-0 mt-0 text-teal" />
                  <h2 className="mt-0 p-relative">Our Mission</h2>
                  <p style={{ fontSize: "20px" }}>
                    To guide you to create the best version of yourself; both
                    personally and professionally.
                    <br />
                    <span className="">
                      <strong>Play a game worth playing.</strong>
                    </span>
                    <br />
                  </p>
                  <Link
                    to="/about-us"
                    className="btn-global hvr-bounce-to-right mt-5"
                    type="button"
                  >
                    <i class="fa fa-book mr-2" /> Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid svc-section">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6 svc-img2" />
                <div className="col-lg-3 col-sm-6 svc-content hvr-shutter-out-horizontal">
                  <div className="row">
                    <div className="col-lg-4 d-flex justify-content-center align-items-center">
                      <img
                        className="mb-3"
                        style={{ maxWidth: "80px" }}
                        src={svcIcon1}
                        alt="Business Improvement Services"
                      />
                    </div>
                    <div className="col-lg-8 d-flex justify-content-center align-items-center">
                      <h5 className="mt-0 mb-0 p-0 text-white text-uppercase">
                        <strong>Business Improvement Services</strong>
                      </h5>
                    </div>
                  </div>
                  <p className="text-white mt-4">
                    Align the critical aspects of your business. Culture,
                    strategy, structure, leadership…
                  </p>
                  <Link
                    className="text-white p-0 m-0 text-decoration-none hvr-wobble-horizontal learn-more"
                    to="/what-we-do"
                  >
                    Learn More
                    <i
                      className="fa fa-caret-right ml-3"
                      style={{ fontSize: "16px" }}
                    />
                  </Link>
                </div>
                <div className="col-lg-3  col-sm-6 svc-content hvr-shutter-out-horizontal">
                  <div className="row">
                    <div className="col-lg-4 d-flex justify-content-center align-items-center">
                      <img
                        className="mb-3"
                        style={{ maxWidth: "80px" }}
                        src={svcIcon2}
                        alt="Business Improvement Services"
                      />
                    </div>
                    <div className="col-lg-6  d-flex justify-content-center align-items-center">
                      {" "}
                      <h5 className="mt-0 mb-0 p-0 text-white text-uppercase">
                        <strong>Organizational Risk Assessments</strong>
                      </h5>
                    </div>
                  </div>

                  <p className="text-white mt-4">
                    By performing our unique Corporate CAT-Scan, we, faster than
                    any other, discover...
                  </p>
                  <Link
                    className="text-white p-0 m-0 text-decoration-none hvr-wobble-horizontal learn-more"
                    to="/risk-assessment-and-development-tools"
                  >
                    Learn More
                    <i
                      className="fa fa-caret-right ml-3"
                      style={{ fontSize: "16px" }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-md-4 mil-section"></div> */}
            <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center mil-section">
              <div className="mil-content p-relative">
                <h2 className="mt-0 p-relative">The Millennial Project</h2>
                <p>
                  There has been so much written about the current generation.
                  How they act, how they think, what they believe, how they are
                  SO Different! Every generation has their differences and
                  idiosyncrasies. Millennials follow the same generational
                  patterns, they simply
                  <strong className="ml-1">
                    have been given different tools.
                  </strong>
                </p>
                <a
                  href="http://www.themillennialproject.co/"
                  className="hvr-bounce-to-right mt-3 btn-global"
                  target="_blank"
                  rel="noreferrer"
                >
                  Visit The Project
                </a>
              </div>
            </div>
            <div className="col-12 col-lg-6 review-section text-white">
              <div className="">
                <div className="col-10 mx-auto pl-0 pb-4 mt-0 ">
                  <h2 className="mt-0 pb-5">Reviews</h2>
                  <SwiperTest />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container-fluid contact-section contact-clean"
          id="contact-us"
        >
          <WebriQForm
            name="Contact Form"
            className="webriq-form"
            data-form-id="bad7dcb4-cb13-445c-89a0-f5b227a8a179"
            data-thankyou-url="/thank-you"
          >
            <h2 className="text-center">Contact us</h2>
            <div className="form-group">
              <input
                type="text"
                name="Name"
                className="form-control"
                id="InputName"
                placeholder="Fullname"
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="Email Address"
                className="form-control"
                id="InputEmail1"
                aria-describedby="emailHelp"
                placeholder="Email Address"
              />

              <small id="emailHelp" className="form-text text-muted">
                We’ll never share your email with anyone else.
              </small>
            </div>
            <div className="form-group">
              <input
                type="text"
                name="Phone Number"
                className="form-control"
                id="InputPhone"
                placeholder="Phone Number"
              />
            </div>

            <div className="form-group">
              <textarea
                name="Message"
                className="form-control h-auto"
                id="InputMessage"
                rows={4}
                placeholder="Your Message"
              />
            </div>
            <div className="form-group">
              <div className="webriq-recaptcha" />
            </div>
            <button
              type="submit"
              className="btn-global w-100 hvr-bounce-to-right"
            >
              Submit
            </button>
          </WebriQForm>
        </div>
      </Layout>
    )
  }
}

export default IndexPage

export const indexPageQuery = graphql`
  query indexPageQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
    allSanityPost(sort: { order: ASC, fields: publishedAt }, limit: 3) {
      edges {
        node {
          id
          title
          banner {
            asset {
              fluid {
                src
              }
            }
          }
          slug {
            current
          }
          excerpt
          publishedAt(formatString: "MMMM DD, YYYY")
        }
      }
    }
  }
`
